<template>
  <v-layout>

    <!-- Filter Section -->
    <v-container>
        <div>
          <v-select
            v-model="selectedApproval"
            :items="approvalStatuses"
            label="Select Approval Status"
            @change="applyFilters"
          ></v-select>
        </div>
        
    <!-- Expenses Section -->
        <div v-for="expense in filteredExpenses" :key="expense.claim_id">
          <v-card style="margin-bottom: 15px;">
            <v-card-title :style="getClassForCard(expense.accepted)"><span><strong>{{ expense.type }}</strong></span> <span><strong>{{ formatDateTime(expense.date) }}</strong></span> </v-card-title>
            <v-card-text>
              <div style="display:flex; flex-direction: row;">
              <strong><p :style="colourForAction(expense.accepted)">{{ actioned(expense.accepted) }}&nbsp;</p></strong>
              <strong><p :style="colourForAction(expense.accepted)" v-if="expense.accepted_date">{{ formatDateTime(expense.accepted_date) }}</p></strong>
              </div>
              <p v-if="expense.description">Description: {{ expense.description }}</p>
              <p v-if="expense.type === 'Parking' && expense.location && (taSettings.parking_location_provider.value == '1' || taSettings.parking_location_provider.value == '2')">Location: {{ expense.location }}</p>
              <p v-if="expense.type === 'Parking' && expense.provider && (taSettings.parking_location_provider.value == '1' || taSettings.parking_location_provider.value == '2')">Provider: {{ expense.provider }}</p>
              <p>Amount: {{ currency(expense.amount, expense.currency) }} {{expense.currency}}</p>
              <v-btn color="accent" v-if="expense.img" @click="viewImage(expense.img)">View Image</v-btn>
                <h3 v-if="filteredExpenseAudit.some(audit => audit.label === expense.claim_id)" style="margin-top:10px; font-weight: bold; font-size: 1em;">Claim Audit Log:</h3>
                <div style="border: 1px solid #eee; padding: 10px; border-radius: 5px;" v-for="audit in filteredExpenseAudit" v-if="audit.label === expense.claim_id" :key="audit.label">
                <div v-for="item in audit.audits" :key="item.id">
                  <p><i>{{ formatDateTime(item.entry_date) }}</i> - <strong>{{ item.user_id }}</strong> : {{ item.comment }}</p>
                </div>
                </div>
            </v-card-text>
          </v-card>
        </div>
    </v-container>
  </v-layout>
</template>

<script>
import '../assets/css/materialdesignicons.min.css'
import axios from 'axios'

export default {
  data () {
    return {
      company: this.$store.getters.company,
      currentCurrency: this.$store.getters.currency,
      url: this.$store.getters.url,
      expenses: [],
      filteredExpenses: [],
      filteredExpenseAudit: [],
      expensesAudit: [],
      selectedApproval: 'All',
      approvalStatuses: [
        { text: 'All', value: 'All' },
        { text: 'Accepted', value: 1 },
        { text: 'Rejected', value: 0 },
        { text: 'Not Actioned', value: null }
      ]
    }
  },
  created () {
    this.getExpenses()
  },
  computed: {
    taSettings () {
      return this.$store.getters.taSettings
    }
  },
  methods: {
    currency (value, currency) {
      if (!value) return '0.00'
      value = value.toString()
      if (currency === 'miles') {
        return parseFloat(value / 100).toFixed(2)
      } else if (currency === 'gbp') {
        return (parseFloat(value) / 100).toFixed(2)
      } else if (currency === 'euro') {
        return (parseFloat(value) / 100).toFixed(2)
      } else {
        return value
      }
    },
    getExpenses () {
      const obj = { empID: this.$store.getters.user.empID, company: this.company }
      axios.post(this.url + `/tanda-service/getExpenses.ajax.php`, obj)
        .then(response => {
          this.expenses = response.data
          this.filteredExpenses = this.expenses // Initialize filtered expenses
          this.getExpensesAudit()
        })
        .catch(e => {
          console.log(e)
        })
    },

    getExpensesAudit () {
      const obj = { empID: this.$store.getters.user.empID, company: this.company }
      axios.post(this.url + `/tanda-service/getExpensesAudit.ajax.php`, obj)
        .then(response => {
          this.expensesAudit = response.data
          this.filterAudit()
        })
        .catch(e => {
          console.log(e)
        })
    },

    formatDateTime (dateTime) {
      const date = new Date(dateTime)
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${day}/${month}/${year} - ${hours}:${minutes}`
    },

    viewImage (img) {
      window.open(img, '_blank')
    },

    getClassForCard (accepted) {
      if (accepted === 1) {
        return 'height:60px; border-bottom: solid 5px #008000; display: flex; flex-direction:column; justify-content: space-between; align-content: space-between;'
      } else if (accepted === 0) {
        return 'height:60px; border-bottom: solid 5px #B30000; display: flex; flex-direction:column; justify-content: space-between; align-content: space-between;'
      } else {
        return 'height:60px; border-bottom: solid 5px #808080; display: flex; flex-direction:column; justify-content: space-between; align-content: space-between;'
      }
    },

    actioned (actioned) {
      if (actioned === 1) {
        return 'Accepted On'
      } else if (actioned === 0) {
        return 'Rejected On'
      } else {
        return 'Not Actioned'
      }
    },

    colourForAction (accepted) {
      if (accepted === 1) {
        return 'color: #008000;'
      } else if (accepted === 0) {
        return 'color: #B30000;'
      } else {
        return ''
      }
    },

    applyFilters () {
      if (this.selectedApproval === 'All') {
        this.filteredExpenses = this.expenses
      } else {
        this.filteredExpenses = this.expenses.filter(expense => expense.accepted === this.selectedApproval)
      }
    },

    filterAudit () {
      this.filteredExpenseAudit = []
      const auditMap = {}
      this.expensesAudit.forEach(audit => {
        const claimId = audit.claim_id
        if (!auditMap[claimId]) {
          auditMap[claimId] = {
            label: claimId,
            audits: []
          }
        }
        auditMap[claimId].audits.push(audit)
      })
      this.filteredExpenseAudit = Object.values(auditMap)
      console.log(this.filteredExpenseAudit)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ViewExpenses.vue